import { styled } from "baseui";

export const StyledRoot = styled<"div", { $backgroundColor; $color }>(
  "div",
  ({ $theme, $backgroundColor, $color }) => ({
    backgroundColor: $backgroundColor,
    color: $color,
    borderStartStartRadius: $theme.borders.radius400,
    borderStartEndRadius: $theme.borders.radius400,
    borderEndStartRadius: $theme.borders.radius400,
    borderEndEndRadius: $theme.borders.radius400,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: $theme.sizing.scale300,
    marginBottom: $theme.sizing.scale300,
    marginLeft: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600,
    paddingTop: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale600,
    paddingLeft: $theme.sizing.scale600,
  })
);

export const StyledHeaderContent = styled<
  "div",
  {}
  // @ts-ignore
>("div", ({ $theme }) => {
  return {
    alignItems: "center",
    display: "flex",
    paddingInlineStart: $theme.sizing.scale600,
    flexDirection: "column",
  };
});

export const StyledIcon = styled<
  "div",
  {}
  // @ts-ignore
>("div", ({ $theme }) => {
  return {
    opacity: 0.7,
  };
});

export const StyledHeader = styled<"div", {}>("div", ({ $theme }) => {
  return $theme.typography.LabelMedium;
});

export const StyledMessage = styled<"div", {}>("div", ({ $theme }) => {
  return {
    ...$theme.typography.ParagraphXSmall,
    textAlign: "center",
  };
});

export const StyledMessageContainer = styled<
  "div",
  {}
  // @ts-ignore
>("div", ({ $theme }) => {
  return {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    paddingInlineStart: $theme.sizing.scale600,
  };
});
